import { withInstall as t } from "../../utils/with-install.js";
import m from "./image.vue.js";
/* empty css           */
const i = t(m);
export {
  i as ApImage,
  i as default
};
